import { ProductDetail } from "@command-center-app/index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProductState {
  productDetails: ProductDetail | null;
  productStatusList: { label: string; value: string }[];
  productInventoryStatusList: { label: string; value: string }[];
  loading: boolean;
  error: string | null;
}

const initialState: ProductState = {
  productDetails: null,
  productStatusList: [],
  productInventoryStatusList: [],
  loading: false,
  error: null,
};

const productSlice = createSlice({
  name: "productInfo",
  initialState,
  reducers: {
    fetchProductStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchProductSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.productDetails = action.payload;
    },
    fetchProductFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    setProductStatusList(
      state,
      action: PayloadAction<{ label: string; value: string }[]>
    ) {
      state.productStatusList = action.payload;
    },
    setProductInventoryStatusList(
      state,
      action: PayloadAction<{ label: string; value: string }[]>
    ) {
      state.productInventoryStatusList = action.payload;
    },
    clearProduct(state) {
      state.productDetails = null;
      state.error = null;
    },
  },
});

export const {
  fetchProductStart,
  fetchProductSuccess,
  fetchProductFailed,
  setProductStatusList,
  setProductInventoryStatusList,
  clearProduct,
} = productSlice.actions;

export default productSlice.reducer;
